var render = function render(_c,_vm){return _c('span',{staticClass:"stamp",style:(`transform: translate(-50%, -50%) rotate(${_vm.props.rotation}deg);
 color: var(--v-${_vm.props.color}-base);
 border: ${_vm.props.border} var(--v-${_vm.props.color}-base);
border-radius: ${_vm.props.radius};
`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }